import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import Avatar from '@/common/components/Avatar/Avatar';
import styles from './MultiValueAssigneeOption.module.less';
function MultiValueAssigneeOption(props) {
    const { option } = props;
    const assignee = option.data.data;
    return (_jsxs("div", { className: styles.userSelectedOption, children: [_jsx(Avatar, { size: "small", username: option.label }), _jsx("span", { className: styles.userSelectedOptionName, children: assignee.shortName })] }));
}
export default observer(MultiValueAssigneeOption);
